import Vue from 'vue'
import axios from 'axios'
import { aesEncrypt, aesDecrypt } from './mycrypto';

axios.defaults.headers["Content-Type"] = "application/json; charset=UTF-8"

import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
Vue.use(NProgress)

// 1. 创建新的axios实例，
const instance = axios.create({
    baseURL: process.env.VUE_APP_SERVER,
    withCredentials: true,
    //responseType: 'json',
    headers: {
        // 'X-Requested-With': 'XMLHttpRequest',
        'Cache-Control': 'no-store' // IE 禁用缓存 // 'no-cache'
    },
    timeout: 60 * 1000,
    transformRequest: [
        function (data,headers) {
            if (data!==null && data!==undefined) {
                // 一、请求参数加密
                if(headers['Content-Type']==='multipart/form-data'){
                    delete headers['Content-Type']
                    return data
                }
                data = JSON.stringify(data)
                return data
            }
            return data
        }
    ],
    transformResponse: [
        function (data) {
            if (data!==null && data!==undefined) {
                try {
                    //data = aesDecrypt(data) || '{}'
                    data = JSON.parse(data)
                } catch (err) {
                }
                return data
            }
        }
    ]
})

// 2. 添加请求拦截器
instance.interceptors.request.use(res => {
    NProgress.start()
    let params = res.url.split("/")[1]
    if(params==='manager'){
        let sysToken =sessionStorage.getItem("sys-token");
        if(null!=sysToken){
            let user=JSON.parse(sessionStorage.getItem("loginUser"))
            res.headers.token=sysToken
            res.headers.userId=user.id
            return res;
        }
    }

    return res;
}, error => {
    // 对请求错误做些什么
    console.log('request-err', error);
    Message.error(error);
    return Promise.reject(error);
});

let retry = 2 // 重发次数
let retryDelay = 200 // 重发时延

// 3. 添加响应拦截器
instance.interceptors.response.use(response => {
    // 对响应数据做点什么
    NProgress.done()
    if(response.data==="500-lanjie"){
        alert("当前账户已在另一处登录，您已被迫下线")
        sessionStorage.clear()
    }
    if(response.data==="500-weblanjie"||response.data==="500-webnolg"){
        router.push({
            name: "bind",
            params: {"openid": store.state.openid}
        })
    }
    if(response.data==="401-auth"|| response.data==="500-nolg"){
        window.location.href="/error-401.html"
    }

    return response
}, error => {
    // 对响应错误做点什么
    console.log('response-err', error);
    /***** 处理结束 *****/
    return Promise.reject(error);

});

// 手动挂载2个方法
instance.all = axios.all
instance.spread = axios.spread
//4.导出文件
export default instance